module.exports = "<p>\n  party-parameter-mapping works!\n</p>\n"